/** @format */

import ResourcesIndexUI from "./resourceIndexUI/ResourcesIndexUI";
import { useGetResourcesFromSubjectQuery } from "../../app/services/subjectApi";
import { skipToken } from "@reduxjs/toolkit/query";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import React from "react";
import { useLocale } from "../../i18n/hooks";
import { useTranslation } from "react-i18next";
import { useSubject } from "../subject/SubjectPage";

const ResourceIndex: React.FC<{}> = () => {
  const { subject } = useSubject();
  const locale = useLocale();
  const { t: _ } = useTranslation();
  const { data, isLoading } = useGetResourcesFromSubjectQuery(
    subject ? { code: subject.id, locale: locale } : skipToken,
  );

  return (
    <div>
      <BreadCrumb />
      {isLoading ? (
        <div className="alert alert-info">{_("Loading")}...</div>
      ) : (
        <ResourcesIndexUI subject={subject} resources={data} />
      )}
    </div>
  );
};

export default ResourceIndex;
